import { render, staticRenderFns } from "./AssignPropertyRequest.vue?vue&type=template&id=6f88e315&"
import script from "./AssignPropertyRequest.vue?vue&type=script&lang=js&"
export * from "./AssignPropertyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports